import { render, staticRenderFns } from "./ServiceNotes.vue?vue&type=template&id=5ee3bdb8&scoped=true&"
import script from "./ServiceNotes.vue?vue&type=script&lang=js&"
export * from "./ServiceNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee3bdb8",
  null
  
)

export default component.exports